// ══════════════════════════════════════════════════════════════════════════════════════════════
//  VIBRAR SIN PARAR, HASTA QUE SE PARE (B-875 · el Busca, 26-sep-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: «al pulsar sobre un usuario, su app empiece a vibrar constantemente hasta que se pare». Un pulso cada
//  `cadaMs` hasta que se llama a la función que devuelve `empezarAVibrar`. Con qué se vibra depende de dónde corre:
//   · la app del móvil con el complemento de vibración (Capacitor Haptics, registrado al arrancar en push/registrarPush):
//     lo usa, pero solo si la app COMPILADA lo lleva dentro (Capacitor.isPluginAvailable). Una app compilada antes del
//     complemento lo tendría registrado en JavaScript sin tenerlo dentro, y llamarle no vibraría: ahí, lo que sigue;
//   · un navegador que sabe vibrar (Chrome en Android, y la app de Android con su permiso): navigator.vibrate;
//   · el iPhone en el navegador no deja vibrar a ninguna página: ahí suena y se ve a pantalla completa, que es lo que
//     hace el aviso del Busca en cualquier caso (components/busca/BuscaEntrante).
//  Nunca lanza: si no se puede vibrar, no pasa nada.
export function comoVibrar(entorno) {
  const w = entorno || (typeof window !== 'undefined' ? window : null)
  const cap = w && w.Capacitor
  const H = cap && cap.Plugins && cap.Plugins.Haptics
  if (H && typeof H.vibrate === 'function' && (typeof cap.isPluginAvailable !== 'function' || cap.isPluginAvailable('Haptics'))) return 'app'
  const nav = w && w.navigator
  if (nav && typeof nav.vibrate === 'function') return 'navegador'
  return null
}

export function empezarAVibrar({ cadaMs = 2000, entorno } = {}) {
  const w = entorno || (typeof window !== 'undefined' ? window : null)
  const modo = comoVibrar(w)
  if (!modo) return () => {}
  const pulso = () => {
    try {
      // El complemento contesta con una promesa: si falla, que no quede un error suelto cada dos segundos.
      if (modo === 'app') { const r = w.Capacitor.Plugins.Haptics.vibrate({ duration: 900 }); if (r && typeof r.catch === 'function') r.catch(() => {}) }
      else w.navigator.vibrate([700, 250, 700])
    } catch { }
  }
  pulso()
  const t = setInterval(pulso, cadaMs)
  return () => {
    clearInterval(t)
    try { if (modo === 'navegador') w.navigator.vibrate(0) } catch { }
  }
}
